'use client';

import { ArrowIcon } from '@insta-club/components';
import { cn } from '@insta-club/utilities';
import { useRouter } from 'next/navigation';

interface Props {
    title: string | React.ReactNode;
    showBackButton?: boolean;
    className?: string;
}

export default function BackHeader({ title, showBackButton = true, className }: Props) {
    const router = useRouter();

    return (
        <div className={cn('fixed top-0 z-[39] h-11 w-full max-w-[var(--container-max)] bg-white', className)}>
            <div className='relative flex h-full w-full items-center px-6 py-4'>
                {showBackButton && (
                    <button className='cursor-pointer' onClick={() => router.back()}>
                        <ArrowIcon />
                    </button>
                )}
                <h1 className='absolute top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 text-sm font-medium'>
                    {title}
                </h1>
            </div>
        </div>
    );
}

